import { NavLink, useLocation } from 'react-router-dom'
import { ReactNode } from 'react'

const tabs = [
  { to: '/', label: '赛道' },
  { to: '/news', label: '动态' },
  { to: '/pricing', label: '定价' },
  { to: '/discover', label: '发现' }
]

export default function Layout({ children }: { children: ReactNode }) {
  const loc = useLocation()
  const onDetail = loc.pathname.startsWith('/sector/')
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-border bg-card sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-6">
          <NavLink to="/" className="flex items-center gap-2">
            <div className="w-7 h-7 rounded bg-gradient-to-br from-blue to-teal flex items-center justify-center text-white font-bold text-sm">B</div>
            <div>
              <div className="text-white font-semibold text-sm">紫苏叶 · 瓶颈投资</div>
              <div className="text-muted text-xs hidden sm:block">真需求 · 硬供给 · 低关注</div>
            </div>
          </NavLink>
          {!onDetail && (
            <nav className="flex gap-1 ml-auto">
              {tabs.map(t => (
                <NavLink key={t.to} to={t.to} end={t.to === '/'}
                  className={({ isActive }) => `px-3 py-1.5 rounded text-sm transition ${isActive ? 'bg-blue text-white' : 'text-muted hover:text-white'}`}>
                  {t.label}
                </NavLink>
              ))}
            </nav>
          )}
          {onDetail && (
            <NavLink to="/" className="ml-auto text-muted text-sm hover:text-white">← 返回</NavLink>
          )}
        </div>
      </header>
      <main className="flex-1 max-w-6xl w-full mx-auto px-4 py-6">{children}</main>
      <footer className="border-t border-border py-4 text-center text-muted text-xs">
        数据仅供参考，不构成投资建议
      </footer>
    </div>
  )
}
